import { QueryResult, useQuery } from '@apollo/client'

import { GET_PASSENGER_TYPES_AUTOCOMPLETE } from 'features/PassengerTypes/queries-legacy'
import { GTPassengerTypesAutocompleteInput, GTPassengerTypesAutocompleteOutput } from 'gql/types.generated'

interface IQueryData {
  passengerTypesAutocomplete: GTPassengerTypesAutocompleteOutput[]
}

interface IUsePassengerTypesAutocompleteInput {
  queryInput: GTPassengerTypesAutocompleteInput
}

export const usePassengerTypesAutocomplete = ({
  queryInput
}: IUsePassengerTypesAutocompleteInput): QueryResult<IQueryData> => {
  return useQuery(GET_PASSENGER_TYPES_AUTOCOMPLETE, {
    fetchPolicy: 'no-cache',
    variables: {
      input: queryInput
    }
  })
}
